import { VideoPostData } from '../../model/types/VideoPostData';
import { FileInput, FileInputProps } from './FileInput';

export interface VideoInputProps {
    value: VideoPostData;
    onChange?: (value: VideoPostData) => void;
}

export const VideoPostInput = ({ value, onChange }: VideoInputProps) => {
    const onVideoUrlChange: FileInputProps['onChange'] = (file) => {
        onChange?.({
            ...value,
            videoUrl: file?.url,
        });
    };

    return (
        <div>
            <fieldset>
                <legend>Video</legend>
                <FileInput
                    allowedFileTypes="video"
                    value={
                        value.videoUrl !== undefined
                            ? {
                                  url: value.videoUrl,
                                  fileType: 'video',
                              }
                            : undefined
                    }
                    onChange={onVideoUrlChange}
                />
            </fieldset>
        </div>
    );
};
